let shareUrl = {
    init: () => {
        const shareButtons = document.querySelectorAll('.js-share-button');

        if (shareButtons) {
            for (let btn of shareButtons) {
                btn.addEventListener('click', async () => {
                    try {
                        const shareData = {
                            title: btn.dataset.title,
                            text: btn.dataset.text,
                            url: window.location.href
                        }
                        await navigator.share(shareData);
                    } catch (err) {
                        navigator.clipboard.writeText(window.location.href); // TODO: Let user know link has been copied
                        console.error(`Error: ${err}`);
                    }
                });
            }
        }
    }
}

export default shareUrl;